import { FC } from 'react';
import React, { Linking, View } from 'react-native';
import { TouchableOpacity } from 'react-native-gesture-handler';

import Icon from '@components/shared/Icon/RestyleIcon';
import { URL_HowDoIUpgradeaTeamPlan } from '@src/constants/constants';

import { Box, ShadowBox, Text } from '../Restyle';

const PromoCard: FC = () => {
  return (
    <ShadowBox borderRadius='xs' padding='m' marginTop='m' variant='promoCard'>
      <View testID='my-profile'>
        <TouchableOpacity
          onPress={() => {
            Linking.openURL(URL_HowDoIUpgradeaTeamPlan).catch((err) =>
              console.error('An error occurred', err)
            );
          }}>
          <Box flexDirection='row' justifyContent='space-between'>
            <Box marginTop='s' marginRight='s'>
              <Icon name='Trophy' variant='l' />
            </Box>
            <Box flex={1}>
              <Text
                variant='labelEmphasized'
                color='background'
                marginBottom='xs'>
                LEARN ABOUT TASKTAG TEAM PLANS
              </Text>
              <Text
                variant='bodySecondary'
                color='background'
                marginBottom='xs'
                paddingRight='m'>
                Browse plans to create unlimited projects and get more storage
                for your organization!
              </Text>

              <Box
                flexDirection='row'
                justifyContent='space-between'
                marginBottom='xs'>
                <Box>
                  <Icon name='ArrowUpRight' variant='l' color='background' />
                </Box>
                <Box flex={1}>
                  <Text variant='bodySecondary' color='background'>
                    50 GB Storage.
                  </Text>
                </Box>
              </Box>
              <Box flexDirection='row' justifyContent='space-between'>
                <Box>
                  <Icon name='ArrowUpRight' variant='l' color='background' />
                </Box>
                <Box flex={1}>
                  <Text variant='bodySecondary' color='background'>
                    Create unlimited Projects.
                  </Text>
                </Box>
              </Box>
            </Box>
          </Box>
        </TouchableOpacity>
      </View>
    </ShadowBox>
  );
};
export default PromoCard;
